module.exports = __webpack_public_path__ + "img/coinbankB44.e2e3ee8d.jpg";